/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringOwnFundDto } from '../../models/backend-monitoring-own-fund-dto';

export interface MonitoringScenariosOwnFundsList$Params {
  scenario_id: number;
}

export function monitoringScenariosOwnFundsList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosOwnFundsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMonitoringOwnFundDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosOwnFundsList.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMonitoringOwnFundDto>>;
    }),
  );
}

monitoringScenariosOwnFundsList.PATH = '/api/monitoring/scenarios/{scenario_id}/own-funds/';
